// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPractice {
    static getAttributeTypeMap() {
        return MedicalEligibilityPractice.attributeTypeMap;
    }
}
MedicalEligibilityPractice.discriminator = undefined;
MedicalEligibilityPractice.additionalProperties = false;
MedicalEligibilityPractice.attributeTypeMap = [
    {
        "name": "additionalId",
        "baseName": "additionalId",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalEligibilityAddress"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPractice.js.map